define('home/templates/channelFeedEmpty',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : {}, alias2=container.escapeExpression;

  return "<div class=\"empty-message card-wrap\">\n<img class=\"empty-message__img\" src=\""
    + alias2(helpers.urlfor.call(alias1,"cdn",{"name":"urlfor","hash":{},"data":data}))
    + "/img/empty-states/discussions.png\"/>\n<div class=\"empty-message__content\">\n<h2 class=\"text-larger\">"
    + alias2(helpers.gettext.call(alias1,"This channel doesn't have any discussions yet.",{"name":"gettext","hash":{},"data":data}))
    + "</h2>\n<p class=\"text-gray text-medium\">"
    + alias2(helpers.gettext.call(alias1,"Discussions started by people in this channel will appear here.",{"name":"gettext","hash":{},"data":data}))
    + "</p>\n<a href=\"/home/discuss/"
    + alias2(container.lambda(((stack1 = (depth0 != null ? depth0.primaryForum : depth0)) != null ? stack1.id : stack1), depth0))
    + "/\" class=\"button button-outline button-padding-wider text-large\">\n"
    + alias2(helpers.gettext.call(alias1,"Start the first discussion",{"name":"gettext","hash":{},"data":data}))
    + "\n</a>\n</div>\n</div>\n";
},"useData":true})

});
